import v1searchQuery from './v1searchQuery'

export default [v1searchQuery]
